export default __webpack_public_path__ + "static/omega-logo-09785c97d1bc8206c3e733b952338865.png";